import state from './moduleBillingDocLinkageState.js'
import mutations from './moduleBillingDocLinkageMutation.js'
import actions from './moduleBillingDocLinkageActions.js'
import getters from './moduleBillingDocLinkageGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

